import type { Message } from "./types";

export interface Tree {
  byId: Map<string, Message>;
  children: Map<string | null, Message[]>;
}

export function buildTree(messages: Message[]): Tree {
  const byId = new Map(messages.map((m) => [m.id, m]));
  const children = new Map<string | null, Message[]>();
  for (const m of messages) {
    const key = m.parent_id;
    if (!children.has(key)) children.set(key, []);
    children.get(key)!.push(m);
  }
  for (const list of children.values()) list.sort((a, b) => a.created_at.localeCompare(b.created_at));
  return { byId, children };
}

/** Root-to-leaf path ending at `leafId`. */
export function pathTo(tree: Tree, leafId: string | null): Message[] {
  const path: Message[] = [];
  let node = leafId ? tree.byId.get(leafId) : undefined;
  while (node) {
    path.push(node);
    node = node.parent_id ? tree.byId.get(node.parent_id) : undefined;
  }
  return path.reverse();
}

/** Newest leaf below `id`, following the newest child at each level. */
export function newestLeaf(tree: Tree, id: string): string {
  let cur = id;
  for (;;) {
    const kids = tree.children.get(cur);
    if (!kids?.length) return cur;
    cur = kids[kids.length - 1].id;
  }
}

export function siblings(tree: Tree, m: Message): Message[] {
  return tree.children.get(m.parent_id) ?? [m];
}
